<script>
    import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();
    let nutsID;

    function openNUTS() {
        window.open('https://ec.europa.eu/eurostat/web/nuts/nuts-maps')
    }

</script>

<div id="nuts">
    <input type="text" id="input" class="input" name="nuts" placeholder="Insert NUTS ID" bind:value={nutsID} on:keypress={(e) => e.key === "Enter" && nutsID ? dispatch("accept", {nutsID: nutsID}) : ""}/>
    <button type="button" class="info" on:click={openNUTS}><img src="/assets/info.png" alt="i" title="Find NUTS ID"></button>
    <button type="button" class="close" title="Close NUTS request" on:click={() => dispatch("close")}>X</button>
    {#if nutsID}
        <button type="button" class="accept" title="Submit" on:click={() => dispatch("accept", {nutsID: nutsID})}>✓</button>
    {/if}
</div>

<style>
    #nuts {
        position: absolute;
        display: flex;
        flex-direction: row;
        top: 180px;
        left: 60px;
        height: 40px;
    }
    img {
        position: relative;
        left: -2px;
        top: 2px;
        height: 20px;
        width: 20px;
    }
    .info {
        cursor: pointer;
        width: 30px;
        height: 100%;
        font-family: Calibri Light, sans-serif;
        font-size: 13px;
        border-radius: 4px;
        border: solid 1px #cccccc;
        box-shadow: 1px 1px #dbdbdb;
    }
    .input {
        height: 100%;
        width: 120px;
        font-family: Calibri Light, sans-serif;
        font-size: 15px;
        background-color: #f4f4f4;
        border: solid 1px #cccccc;
        box-shadow: 1px 1px #dbdbdb;
        border-radius: 4px;
    }
    .close {
        background-color: #696969;
        color: white;
        cursor: pointer;
        width: 30px;
        height: 100%;
        font-family: Calibri Light, sans-serif;
        font-weight: bold;
        font-size: 18px;
        border-radius: 4px;
        border: solid 1px #cccccc;
        box-shadow: 1px 1px #dbdbdb;
    }
    .accept {
        background-color: #99e599;
        color: #696969;
        cursor: pointer;
        width: 30px;
        height: 100%;
        font-family: Calibri Light, sans-serif;
        font-weight: bold;
        font-size: 18px;
        border-radius: 4px;
        border: solid 1px #696969;
        box-shadow: 1px 1px #dbdbdb;
    }
</style>